module.exports = __webpack_public_path__ + "assets/img/btn-detail-31fc1274.png";